import { render, staticRenderFns } from "./chat-client-messages.vue?vue&type=template&id=6039bef8&scoped=true"
import script from "./chat-client-messages.vue?vue&type=script&lang=js"
export * from "./chat-client-messages.vue?vue&type=script&lang=js"
import style0 from "./chat-client-messages.vue?vue&type=style&index=0&id=6039bef8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6039bef8",
  null
  
)

export default component.exports